import { lazyPage } from './lazyPage';
import type { AppRoute } from './types';
import { academicsRoutes } from './academicsRoutes';
import { administrationRoutes } from './administrationRoutes';
import { admissionsRoutes } from './admissionsRoutes';
import { assessmentRoutes } from './assessmentRoutes';
import { attendanceRoutes } from './attendanceRoutes';
import { communicationRoutes } from './communicationRoutes';
import { examinationRoutes } from './examinationRoutes';
import { facilityRoutes } from './facilityRoutes';
import { feesRoutes } from './feesRoutes';
import { healthRoutes } from './healthRoutes';
import { hostelRoutes } from './hostelRoutes';
import { libraryRoutes } from './libraryRoutes';
import { peopleRoutes } from './peopleRoutes';
import { schoolRoutes } from './schoolRoutes';
import { sportsRoutes } from './sportsRoutes';
import { timetableRoutes } from './timetableRoutes';
import { transportRoutes } from './transportRoutes';

const AdminHome = lazyPage(() => import('@/pages/AdminHome'));
const Dashboard = lazyPage(() => import('@/pages/Dashboard'));
const ReportsAnalytics = lazyPage(() => import('@/pages/portal/ReportsAnalytics'));
const DocumentPermissions = lazyPage(() => import('@/pages/administrator/DocumentPermissions'));
const MyProfile = lazyPage(() => import('@/pages/me/MyProfilePage'));

export const adminRoutes: AppRoute[] = [
  {
    path: 'administrator',
    title: 'Administrator',
    children: [
      { path: '', title: 'Administrator', component: AdminHome },
      { path: 'dashboard', title: 'Dashboard', component: Dashboard },
      { path: 'reports', title: 'Reports & Analytics', component: ReportsAnalytics },
      { path: 'my-profile', title: 'My Profile', component: MyProfile },
      {
        path: 'settings/document-permissions',
        title: 'Document Permissions',
        component: DocumentPermissions,
      },
      ...academicsRoutes,
      ...timetableRoutes,
      ...peopleRoutes,
      ...admissionsRoutes,
      ...attendanceRoutes,
      ...assessmentRoutes,
      ...examinationRoutes,
      ...transportRoutes,
      ...feesRoutes,
      ...libraryRoutes,
      ...hostelRoutes,
      ...healthRoutes,
      ...sportsRoutes,
      ...facilityRoutes,
      ...communicationRoutes,
      ...schoolRoutes,
      ...administrationRoutes,
    ],
  },
];
